import React from "react";
import BEER1 from "../json/BEER1.json";
import BEER2 from "../json/BEER2.json";
import BEER3 from "../json/BEER3.json";
import BEER4 from "../json/BEER4.json";

function BEER({ drug }) {
  const filteredResultsBEER1 = BEER1.filter((row) => {
    const drugName = row["Medication Name "].toLowerCase().trim();
    const targetDrugName = drug.toLowerCase().trim();
    return drugName.startsWith(targetDrugName) || drugName.endsWith(targetDrugName);
  });
  const filteredResultsBEER2 = BEER2.filter((row) => {
    const drugName = row["Drugs "].toLowerCase().trim();
    const targetDrugName = drug.toLowerCase().trim();
    return drugName.startsWith(targetDrugName) || drugName.endsWith(targetDrugName);
  });
  const filteredResultsBEER3 = BEER3.filter((row) => {
    const drugName = row["Object Drug and Class"].toLowerCase().trim();
    const targetDrugName = drug.toLowerCase().trim();
    return drugName.startsWith(targetDrugName) || drugName.endsWith(targetDrugName);
  });
  const filteredResultsBEER4 = BEER4.filter((row) => {
    const drugName = row["Medication Class and Medication"].toLowerCase().trim();
    const targetDrugName = drug.toLowerCase().trim();
    return drugName.startsWith(targetDrugName) || drugName.endsWith(targetDrugName);
  });
  return (
    <div className="beer-column">
      {filteredResultsBEER1.map((result, index) => (
        <div className="table-cell" key={index}>
          {drug.trim().length<result["Medication Name "].trim().length && <p> For Drug: {result["Medication Name "]}</p>}
          <p>Recommendation: {result["Recommendation "]}</p>
        </div>
      ))}
      {filteredResultsBEER2.map((result, index) => (
        <div className="table-cell" key={index}>
          {drug.trim().length<result["Drugs "].trim().length && <p>For Drug: {result["Drugs "]}</p>}
          <p>Disease or syndrome: {result["Disease or syndrome "]}</p>
          <p>Recommendation: {result["Recommendation "]}</p>
        </div>
      ))}
      {filteredResultsBEER3.map((result, index) => (
        <div className="table-cell" key={index}>
          {drug.trim().length<result["Object Drug and Class"].trim().length && <p>For Drug: {result["Object Drug and Class"]}</p>}
          <p>Interacting Drug and Class: {result["Interacting Drug and Class"]}</p>
          <p>Recommendation: {result["Recommendation"]}</p>
        </div>
      ))}
      {filteredResultsBEER4.map((result, index) => (
        <div className="table-cell" key={index}>
          {drug.trim().length<result["Medication Class and Medication"].trim().length && <p>For Drug: {result["Medication Class and Medication"]}</p>}
          <p>Creatinine Clearance at Which Action Required, mL/min: {result["Creatinine Clearance at Which Action Required, mL/min"]}</p>
          <p>Recommendation: {result["Recommendation "]}</p>
        </div>
      ))}
      {(filteredResultsBEER1.length===0 && filteredResultsBEER2.length===0 && filteredResultsBEER3.length===0 && filteredResultsBEER4.length===0) && <p>No results found</p>}
    </div>
  );
}

export default BEER;
